export default "__VITE_ASSET__cAhADRdW__"